<dl class="iackathon-step-key-number__description-list">

    @for (entry of keyNumberEntries(); track entry.labelKey) {
        <div class="iackathon-step-key-number__description-container">
            <dt class="iackathon-step-key-number__description-term">
                {{ entry.labelKey | translate }}
            </dt>
            <dd class="iackathon-step-key-number__description-value"
                [class.iackathon-step-key-number__description-value--no-data]="!entry.value">
                {{ entry.value || ('iackathon.data_not_provided' | translate) }}
            </dd>
        </div>
    }

</dl>
